// 1) FOR PROD { publicPath: "/gisdata/"}
//export const config = { publicPath: "/gisdata/"}

// OR 2) FOR LOCAL DEV - DEV - STAGING { publicPath: "/"}
export const config = { publicPath: "/"}

//export const config = { publicPath: "/gisdata/"} 